import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../Core'
import * as tutorialActions from '../tutorial.actions'

class TutorialEndPopup extends React.Component {
  constructor(props) {
    super(props)
  }

  closePopup() {
    const { removePopup, endTutorial } = this.props
    setTimeout(() => {
      removePopup('tutorial_end')
      endTutorial()
    }, 200)
  }

  render() {
    return (
      <div className="popup--game">
        <div className="popup--box">
          <div className="popup--box__canvas">
            <div className="popup--text blue">
              <FormattedMessage id="tutorial.endTutorial" />
            </div>
            <div className="popup--buttons">
              <div
                onClick={() => {
                  this.closePopup()
                }}
                className="btn--shape shape--blue"
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="phase.accept" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    endTutorial: bindActionCreators(tutorialActions.endTutorial, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {}
}

TutorialEndPopup.propTypes = {
  removePopup: PropTypes.func,
  endTutorial: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TutorialEndPopup))
